import { BaseModel } from "../products/base";
import { FabricSwatch } from "../products/fabric";
import { FinishHandle } from "../products/finish";
import { UmbrellaModel } from "../products/umbrella";
import * as option from "./configurator_options";

export type ConfigFile = {
  _id?: string;
  public?: boolean;
  layout: {
    collection?: {
      handle: string;
    };
    productline?: {
      handle: string;
    };
    preset: option.Preset;
  };
  shape: {
    model: string;
  };
  base: {
    base: string | null;
    baseFinish: FinishHandle | null;
    baseStem: option.Stem | null;
  };
  frame: {
    finish: FinishHandle;
    finial: option.Finial;
    finialFinish: FinishHandle | "chrome" | null;
    bottomPole: option.BottomPole | null;
  };
  canopy: {
    mainCanopy: option.Panel;
    mainFabric: string[]; // Array will contain 2 fabric mfr_codes if alternating panels, else 1
    mainTrimFabric: string | null;
    mainTrimFabricInner: string | null;
    ventTopFabric: string[];
    ventMiddle: option.Panel | null;
    ventMiddleFabric: string[]; // Array will contain 2 fabric mfr_codes if alternating panels, else 1
    ventTrimFabric: string | null;
    valance: option.Valance;
    valanceFabric: string[]; // if valance is present, array will contain 2 fabric mfr_codes if main canopy alternating panels, else 1
    bindingFabric: string | null;
    rib: option.Rib | null;
    ribFabric: string | null; // null if rib === 'grommet'
  };
  name?: string;
  image?: string;
  creator_id?: string;
  share_id?: string;
  created_at?: Date | string;
  updated_at?: Date | string;
};

export interface QuickshipConfigFile extends ConfigFile {
  type: ConfigType.QS;
  umbrella?: UmbrellaModel[];
  fabric?: FabricSwatch[];
  baseObject?: BaseModel[];
}

export enum ConfigType {
  QS = "quickship"
}
